import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
    return (
        <section className="min-h-screen bg-appBg dark:bg-appDark py-4 px-6">

            <div className="max-w-6xl mx-auto">

                {/* TITLE */}
                <h1 className="text-4xl font-bold mb-8 text-titleLight dark:text-titleDark">
                    Privacy Policy
                </h1>

                {/* DATE */}
                <p className="mb-6 text-subText dark:text-subTextDark">
                    Last updated: March 2026
                </p>

                {/* CONTENT BOX */}
                <div className="bg-card dark:bg-cardDark border border-borderLight dark:border-borderDark rounded-2xl p-6 md:p-8 space-y-6 text-textMain dark:text-textDark leading-relaxed">

                    <p>
                        This Privacy Policy explains how ClickBoard collects, uses, and protects your information when you use our website. We are committed to ensuring your privacy and providing a safe and secure experience for all users.
                    </p>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            1. Information We Do Not Collect
                        </h2>
                        <p>
                            ClickBoard does not require users to create an account or provide personal information such as name, email address, or phone number.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            2. Information You Provide
                        </h2>
                        <p>
                            When using ClickBoard, you may enter text that you wish to transfer between devices. This data is temporarily stored only to provide the service functionality.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            3. How We Use Your Data
                        </h2>
                        <p>
                            The data you provide is used only to generate a unique code and allow retrieval of your text on another device. We do not use your data for tracking, advertising, or analytics purposes.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            4. Data Storage and Expiry
                        </h2>
                        <ul className="list-disc ml-6">
                            <li>Data is stored temporarily on secure servers</li>
                            <li>Data is automatically deleted after a short period</li>
                            <li>One-time access removes data immediately after retrieval</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            5. Data Security
                        </h2>
                        <p>
                            We use industry-standard security practices to protect your data. However, users are advised not to share sensitive or confidential information using this service.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            6. Third-Party Services
                        </h2>
                        <p>
                            We may use third-party services such as Firebase for secure data storage and management. These services follow their own privacy policies and security standards.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            7. Cookies
                        </h2>
                        <p>
                            ClickBoard may use basic cookies to enhance user experience, such as remembering preferences and improving performance.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            8. Changes to This Policy
                        </h2>
                        <p>
                            We may update this Privacy Policy from time to time. Any changes will be reflected on this page with an updated revision date.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-semibold text-xl mb-2 text-titleLight dark:text-titleDark">
                            9. Contact Us
                        </h2>

                        <p className="mb-2">
                            If you have any questions, feedback, or need support, you can contact us through our contact page.
                        </p>

                        <Link
                            to="/contact"
                            className="text-primary hover:underline font-medium"
                        >
                            Go to Contact Page
                        </Link>
                    </div>

                </div>

                {/* BACK BUTTON */}
                <div className="mt-16">
                    <Link
                        to="/"
                        className="bg-primary hover:bg-primaryHover text-white px-6 py-3 rounded-md transition"
                    >
                        ← Back to Home
                    </Link>
                </div>

                <Footer />

            </div>

        </section>
    );
}